module.exports = __webpack_public_path__ + "static/media/  (46).586e04ab.jpg";